/* Deviceli buyback: offers and rules come from Shopify
   (window.DV_TRADE = one entry per model, window.DV_TRADE_SET = percentages and rules,
   both rendered by snippets/dv-trade-data.liquid). */
(function(){
  if (typeof TRADE === 'undefined') return;
  var S = window.DV_TRADE_SET || {}, D = window.DV_TRADE || [];
  function num(v){ var n = parseFloat(v); return isFinite(n) ? n : null; }
  function pct(v, fallback){ var n = num(v); return n == null ? fallback : n / 100; }

  /* 1. Global percentages */
  if (typeof GRADES_SELL !== 'undefined') GRADES_SELL.forEach(function(g){
    if (g.k === 'good')   g.m = pct(S.good, g.m);
    if (g.k === 'used')   g.m = pct(S.used, g.m);
    if (g.k === 'broken') g.m = pct(S.broken, g.m);
  });
  if (typeof BATT !== 'undefined') BATT.forEach(function(b){
    if (b.k === '85')  b.m = pct(S.b85, b.m);
    if (b.k === '80')  b.m = pct(S.b80, b.m);
    if (b.k === '79')  b.m = pct(S.blow, b.m);
    if (b.k === 'unk') b.m = pct(S.bunk, b.m);
  });
  if (typeof CAP_STEP !== 'undefined' && S.steps) {
    var st = String(S.steps).split(',').map(num).filter(function(x){ return x != null; });
    if (st.length) { CAP_STEP.length = 0; CAP_STEP.push(1); st.forEach(function(x){ CAP_STEP.push(1 + x / 100); }); }
  }
  if (typeof CARRIERS !== 'undefined' && typeof S.blocked === 'string') {
    var bl = S.blocked.split(',').map(function(s){ return s.trim().toLowerCase(); }).filter(Boolean);
    CARRIERS.forEach(function(c){ c[1] = bl.indexOf(c[0].toLowerCase()) >= 0; });
  }
  var NOCTRL = pct(S.noctrl, 0.9), CELL = pct(S.cell, 1.06);
  var MIN = num(S.min); if (MIN == null) MIN = 5;
  var RND = num(S.round); if (!RND || RND < 1) RND = 5;
  window.ctrlMult = function(){ return sell.cat === 'gaming' && sell.ctrl === 'no' ? NOCTRL : 1; };
  window.connMult = function(){ return CONN_CATS.includes(sell.cat) && sell.conn === 'cell' ? CELL : 1; };

  /* 2. Models: price, optional price per grade, storages (optionally with a price each), on/off */
  var OVR = {};
  if (D.length) {
    var keep = {};
    D.forEach(function(r){
      if (!r.m || !TRADE[r.c] || r.on === false) return;
      keep[r.m] = true;
      var base = Math.max(0, Math.round(+r.p || 0));
      var list = TRADE[r.c].list, row = null;
      for (var i = 0; i < list.length; i++) if (list[i][0] === r.m) row = list[i];
      if (row) row[1] = base; else list.push([r.m, base]);
      var o = {};
      if (base > 0) {
        if (num(r.g) != null) o.good = num(r.g) / base;
        if (num(r.u) != null) o.used = num(r.u) / base;
        if (num(r.b) != null) o.broken = num(r.b) / base;
      }
      OVR[r.m] = o;
      if (r.caps && typeof MODEL_CAPS !== 'undefined') {
        var parts = String(r.caps).split(',').map(function(s){ return s.trim(); }).filter(Boolean);
        if (parts.length) MODEL_CAPS[r.m] = parts.map(function(s, i){
          var kv = s.split('='), name = kv[0].trim(), v = kv.length > 1 ? num(kv[1]) : null;
          if (v != null && base > 0) return [name, v / base];
          return [name, CAP_STEP[Math.min(i, CAP_STEP.length - 1)]];
        });
      }
    });
    Object.keys(TRADE).forEach(function(c){
      var list = TRADE[c].list;
      for (var i = list.length - 1; i >= 0; i--) if (!keep[list[i][0]]) list.splice(i, 1);
    });
  }

  /* 3. Offer = model price x storage x options x battery x grade (a fixed grade price replaces the grade %) */
  function gradeMult(g){ var o = OVR[sell.model] || {}; return o[g.k] != null ? o[g.k] : g.m; }
  window.gradePriceSell = function(g){
    var v = modelBase();
    var cap = capList()[sell.storage]; if (cap) v *= cap[1];
    v *= connMult(); v *= ctrlMult(); v *= batteryMult(); v *= gradeMult(g);
    return Math.max(MIN, Math.round(v / RND + 1e-9) * RND);
  };
  window.maxPrice = function(){
    if (sell.storage == null) { var c = capsFor(sell.model); return Math.round(modelBase() * Math.max.apply(null, c.map(function(x){ return x[1]; })) / RND) * RND; }
    var v = modelBase(), cap = capList()[sell.storage]; if (cap) v *= cap[1];
    return Math.round(v * connMult() / RND) * RND;
  };

  /* 4. Buyback paused */
  if (S.open === false) {
    var mail = (window.DV_MAIL && window.DV_MAIL.main) || '';
    window.pageSell = function(){
      return '<section class="shell" style="padding:72px 0;text-align:center;max-width:560px;margin:0 auto">' +
        '<h1 style="font-size:32px;margin:0 0 12px">Buyback is paused</h1>' +
        '<p style="font-size:17px;line-height:1.5;margin:0">We are not taking new trade-ins right now. Please check back soon' +
        (mail ? ', or write to <a class="seclink" href="mailto:' + mail + '">' + mail + '</a>.' : '.') + '</p></section>';
    };
  }

  /* 5. Offer summary: show amounts only, never percentages */
  function tidy(){
    document.querySelectorAll('.qlines li b').forEach(function(b){
      if (/%/.test(b.textContent)) b.textContent = 'Included';
    });
  }
  try { new MutationObserver(tidy).observe(document.getElementById('dv-app') || document.body, { childList: true, subtree: true }); } catch (e) {}
  try { if (typeof route === 'function') route(); } catch (e) {}
  tidy();
})();
